import * as React from "react";
import { ButtonIcon, ButtonIcons } from "@shared/common";
import "./FileRow.scss";
import { IValidation } from "@generation/core";
import { FileErrorMessageBlock } from "./FileErrorMessageBlock";
import { translate } from "../../Locales/translator";

export interface FileRowModel {
  file: File;
}

export interface FileRowProps<T extends FileRowModel> {
  showValidationMessageBelowFile?: boolean;
  fileIndicatorLabel?: string;
  file: T;
  index: number;
  validate?: IValidation[];
  onDelete: (file: T, index: number) => void;
  onDownload?: (resourceId: number) => void;
}

export const FileRow = <T extends FileRowModel>(props: FileRowProps<T>) => {
  return (
    <>
      <div className={`file-row ${props.fileIndicatorLabel ? "file-row__has-file-indicator-label" : ""}`}>
        {props.fileIndicatorLabel && (
          <span className="file-row__file-indicator-label">{`${props.fileIndicatorLabel} ${
            props.index + 1
          }`}</span>
        )}
        <label>{props.file.file.name}</label>
        <div className="file-actions">
          <ButtonIcon
            icon={ButtonIcons.Verwijderen}
            buttonText={translate("Verwijderfile")}
            id={props.file.file.name}
            clickHandler={() => props.onDelete(props.file, props.index)}
          />
          {props.onDownload && (
            <ButtonIcon
              icon={ButtonIcons.Download}
              buttonText={translate("DownloadFile")}
              id={props.file.file.name}
              clickHandler={() => props.onDownload && props.onDownload(Number(props.file.file.type))}
            />
          )}
        </div>
      </div>
      {props.showValidationMessageBelowFile && props.validate && (
        <FileErrorMessageBlock
          file={props.file.file}
          label={
            props.fileIndicatorLabel ? `${props.fileIndicatorLabel} ${props.index + 1}` : props.file.file.name
          }
          validate={props.validate}
        />
      )}
    </>
  );
};
